import type { ReviewSite, SocialMedia } from '~/types';
import { objectKeys } from '~/helpers/general';

const SOCIALS_WITH_REVIEWS: SocialMedia[] = [
  'google', 'facebook', 'yandex'
];

export default function useSocials() {
  const { reviews, socialLinks } = useBranch();
  const { tt } = useLocalization();

  const links = reviews.public ? reviews.links : socialLinks;
  const reviewLinksHtml = objectKeys(links).filter(l => shouldShow(l)).map(social => {
    const url = links[social];
    return `<a href="${url}" target="_blank">${tt(`socials.${social}`)}</a>`;
  }).join(', ');

  return {
    reviewLinksHtml
  };

  function shouldShow(name: SocialMedia | ReviewSite) {
    if (reviews.public) return true;
    return SOCIALS_WITH_REVIEWS.includes(name as SocialMedia);
  }
}